export const INITIALIZE_PAYMENT_METHODS = 'initialize-payment-methods';

const initializePaymentMethods = () => (
  { type: INITIALIZE_PAYMENT_METHODS }
);

export default initializePaymentMethods;
